import { render, staticRenderFns } from "./middleTable_page.vue?vue&type=template&id=53eefe84&scoped=true"
import script from "./middleTable_page.vue?vue&type=script&lang=js"
export * from "./middleTable_page.vue?vue&type=script&lang=js"
import style0 from "./middleTable_page.vue?vue&type=style&index=0&id=53eefe84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eefe84",
  null
  
)

export default component.exports